(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloo-bar-result"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.blooCompareReady) return;
    window.blooCompareReady = true;

    function bind(compare) {
      var range = compare.querySelector('[data-bloo-compare-range]');
      var dragging = false;
      function set(pct) {
        pct = Math.max(0, Math.min(100, pct));
        compare.style.setProperty('--pos', pct + '%');
        if (range) range.value = Math.round(pct);
      }
      function fromPointer(event) {
        var rect = compare.getBoundingClientRect();
        set(((event.clientX - rect.left) / rect.width) * 100);
      }
      compare.addEventListener('pointerdown', function (event) {
        dragging = true;
        compare.setPointerCapture(event.pointerId);
        fromPointer(event);
      });
      compare.addEventListener('pointermove', function (event) { if (dragging) fromPointer(event); });
      compare.addEventListener('pointerup', function () { dragging = false; });
      compare.addEventListener('pointercancel', function () { dragging = false; });
      if (range) range.addEventListener('input', function () { set(Number(range.value)); });
    }

    function init() { document.querySelectorAll('[data-bloo-compare]').forEach(bind); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloo-bar"]) return;
  try {
    
  (function () {
    function ensurePurchaseStickyController() {
      if (window.blooPurchaseStickyControllerReady) return;
      window.blooPurchaseStickyControllerReady = true;
      window.blooRefreshPurchaseStickies = function () {
        var configs = [
          { selector: '[data-bloo-bundle]', className: 'bloo-bundle--sticky-visible', atc: '[data-bloo-bundle-add]' },
          { selector: '[data-bloo-sw]', className: 'bloo-sw--sticky-visible', atc: '[data-bloo-add-to-cart]' },
          { selector: '[data-bloo-bar]', className: 'bloo-bar--sticky-visible', atc: '[data-bloo-bar-add]' }
        ];
        var isMobile = window.matchMedia('(max-width: 768px), (max-width: 932px) and (hover: none) and (pointer: coarse)').matches;
        var cartDrawerOpen = !!document.querySelector('cart-drawer.active') || document.body.classList.contains('overflow-hidden');
        var visualViewport = window.visualViewport;
        var layoutHeight = document.documentElement.clientHeight || window.innerHeight;
        var viewportHeight = visualViewport ? visualViewport.height : (window.innerHeight || layoutHeight);
        var viewportOffsetTop = visualViewport ? visualViewport.offsetTop : 0;
        var stickyBottom = visualViewport ? Math.max(0, layoutHeight - visualViewport.height - viewportOffsetTop) : 0;
        var active = null;
        var mainAddVisible = false;

        document.documentElement.style.setProperty('--bloo-sticky-bottom', stickyBottom + 'px');

        configs.forEach(function (config) {
          document.querySelectorAll(config.selector).forEach(function (section) {
            section.classList.remove(config.className);
            if (!isMobile || cartDrawerOpen) return;

            var rect = section.getBoundingClientRect();
            var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
            if (visibleHeight <= 80) return;

            // The bar duplicates each section's own Add to Cart, so stay hidden while any of those buttons is on screen.

            var mainAdd = config.atc && section.querySelector(config.atc);

            if (mainAdd) {

              var addRect = mainAdd.getBoundingClientRect();

              if (addRect.height && addRect.bottom > 0 && addRect.top < viewportHeight) mainAddVisible = true;

            }

            var centerDistance = Math.abs((rect.top + rect.bottom) / 2 - viewportHeight / 2);
            var score = visibleHeight - centerDistance * 0.01;
            if (!active || score > active.score) {
              active = { section: section, className: config.className, score: score };
            }
          });
        });

	        if (mainAddVisible) active = null;

	        if (active) active.section.classList.add(active.className);
	        document.body.classList.toggle('bloo-purchase-sticky-active', !!active);
	      };

      window.addEventListener('scroll', window.blooRefreshPurchaseStickies, { passive: true });
      window.addEventListener('resize', window.blooRefreshPurchaseStickies);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', window.blooRefreshPurchaseStickies);
        window.visualViewport.addEventListener('scroll', window.blooRefreshPurchaseStickies);
      }
    }

    ensurePurchaseStickyController();

    document.querySelectorAll('[data-bloo-bar]').forEach(function (section) {
      var ingredientCloseTimer = null;

      function closeIngredientCards(exceptKey) {
        section.querySelectorAll('[data-bloo-bar-ingredient-card]').forEach(function (card) {
          if (card.dataset.blooBarIngredientCard !== exceptKey) card.hidden = true;
        });
        section.querySelectorAll('[data-bloo-bar-ingredient]').forEach(function (trigger) {
          if (trigger.dataset.blooBarIngredient !== exceptKey) trigger.setAttribute('aria-expanded', 'false');
        });
      }

      function setIngredientCard(trigger, forceOpen) {
        var key = trigger.dataset.blooBarIngredient;
        var card = section.querySelector('[data-bloo-bar-ingredient-card="' + key + '"]');
        if (!card) return;
        var shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : card.hidden;
        closeIngredientCards(shouldOpen ? key : null);
        card.hidden = !shouldOpen;
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      section.querySelectorAll('[data-bloo-bar-ingredient]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.stopPropagation();
          var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          setIngredientCard(trigger, supportsHover ? true : undefined);
        });
        trigger.addEventListener('mouseenter', function () {
          window.clearTimeout(ingredientCloseTimer);
          setIngredientCard(trigger, true);
        });
        trigger.addEventListener('focus', function () { setIngredientCard(trigger, true); });
        trigger.addEventListener('mouseleave', function () {
          ingredientCloseTimer = window.setTimeout(function () { closeIngredientCards(); }, 140);
        });
      });

      section.querySelectorAll('[data-bloo-bar-ingredient-card]').forEach(function (card) {
        card.addEventListener('mouseenter', function () { window.clearTimeout(ingredientCloseTimer); });
        card.addEventListener('mouseleave', function () {
          ingredientCloseTimer = window.setTimeout(function () { closeIngredientCards(); }, 140);
        });
      });

      section.addEventListener('focusout', function (event) {
        var ingredients = section.querySelector('[data-bloo-bar-ingredients]');
        if (ingredients && !ingredients.contains(event.relatedTarget)) closeIngredientCards();
      });
      document.addEventListener('click', function (event) {
        var ingredients = section.querySelector('[data-bloo-bar-ingredients]');
        if (ingredients && !ingredients.contains(event.target)) closeIngredientCards();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeIngredientCards();
      });

      if (section.dataset.blooBound === 'true') return;
      section.dataset.blooBound = 'true';

      function updateUI() {
        var activePlan = section.dataset.activePlan;
        var activeQty = section.dataset.activeQty;
        var activeFrequency = section.dataset.activeFrequency || 'four';

        section.querySelectorAll('[data-bloo-bar-plan]').forEach(function (tab) {
          var isActive = tab.dataset.blooBarPlan === activePlan;
          tab.classList.toggle('bloo-bar__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('[data-bloo-bar-frequency]').forEach(function (btn) {
          var isActive = btn.dataset.blooBarFrequency === activeFrequency;
          btn.classList.toggle('bloo-bar__frequency-btn--active', isActive);
          btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('[data-bloo-bar-card]').forEach(function (card) {
          var isSelected = card.dataset.qty === activeQty;
          card.classList.toggle('bloo-bar__card--selected', isSelected);
          card.setAttribute('aria-checked', isSelected ? 'true' : 'false');

          var priceEl = card.querySelector('.bloo-bar__price');
          if (priceEl) {
            var newPrice = activePlan === 'onetime'
              ? priceEl.dataset.priceOnetime
              : priceEl.dataset.priceSubscribe;
            if (newPrice) priceEl.textContent = newPrice;
          }

          var subEl = card.querySelector('.bloo-bar__card-sub');
          if (subEl) {
            var newSub = activePlan === 'onetime'
              ? subEl.dataset.subOnetime
              : subEl.dataset.subSubscribe;
            if (newSub) subEl.innerHTML = newSub;
          }
        });

        var selectedCard = section.querySelector('[data-bloo-bar-card][data-qty="' + activeQty + '"]');
        if (selectedCard) {
          var headerPriceEl = section.querySelector('[data-bloo-bar-price]');
          var headerStrikeEl = section.querySelector('[data-bloo-bar-strike]');
          var headerPerDayEl = section.querySelector('[data-bloo-bar-perday]');
          var headerPillEl = section.querySelector('[data-bloo-bar-pill]');

          var cardPriceEl = selectedCard.querySelector('.bloo-bar__price');
          var cardStrikeEl = selectedCard.querySelector('.bloo-bar__strike');

          if (headerPriceEl && cardPriceEl) headerPriceEl.textContent = cardPriceEl.textContent;
          if (headerStrikeEl) {
            if (cardStrikeEl) {
              headerStrikeEl.textContent = cardStrikeEl.textContent;
              headerStrikeEl.style.display = '';
            } else {
              headerStrikeEl.style.display = 'none';
            }
          }
          if (headerPerDayEl) {
            var perDayValue = activePlan === 'onetime'
              ? headerPerDayEl.dataset.perdayOnetime
              : headerPerDayEl.dataset.perdaySubscribe;
            if (perDayValue) headerPerDayEl.textContent = perDayValue;
          }
          if (headerPillEl) {
            var pillMap = { '1': '1 BAR', '2': '2 BARS', '4': '4 BARS' };
            headerPillEl.textContent = pillMap[activeQty] || '';
          }

          var stickyTitle = section.querySelector('[data-bloo-bar-sticky-title]');
          var stickyPrice = section.querySelector('[data-bloo-bar-sticky-price]');
          if (stickyTitle) {
            var titleMap = { '1': '1 Bar', '2': '2 Bars', '4': '4 Bars' };
            stickyTitle.textContent = 'BLOO Bar ' + (titleMap[activeQty] || '');
          }
          if (stickyPrice && headerPriceEl) stickyPrice.textContent = headerPriceEl.textContent;
        }
      }

      function updateStickyState() {
        if (window.blooRefreshPurchaseStickies) window.blooRefreshPurchaseStickies();
      }

      function addSelected(button, idleText) {
        var qty = parseInt(section.dataset.activeQty, 10);
        var sellingPlan = null;
        if (section.dataset.activePlan === 'subscribe') {
          var frequencySuffix = { four: 'Four', six: 'Six', eight: 'Eight' };
          var suffix = frequencySuffix[section.dataset.activeFrequency] || 'Four';
          sellingPlan = section.dataset['sellingPlan' + suffix] || section.dataset.sellingPlanFour;
        }
        var item = { id: section.dataset.variant, quantity: qty };
        if (sellingPlan) item.selling_plan = sellingPlan;
        blooAddToCart(item, button, idleText);
      }

      section.querySelectorAll('[data-bloo-bar-plan]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          section.dataset.activePlan = tab.dataset.blooBarPlan;
          updateUI();
          updateStickyState();
        });
      });

      section.querySelectorAll('[data-bloo-bar-frequency]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          section.dataset.activeFrequency = btn.dataset.blooBarFrequency;
          updateUI();
          updateStickyState();
        });
      });

      section.querySelectorAll('[data-bloo-bar-card]').forEach(function (card) {
        card.addEventListener('click', function () {
          section.dataset.activeQty = card.dataset.qty;
          updateUI();
          updateStickyState();
        });
      });

      section.querySelectorAll('[data-bloo-bar-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          section.querySelectorAll('[data-bloo-bar-thumb]').forEach(function (t) {
            t.classList.remove('bloo-bar__thumb--active');
          });
          thumb.classList.add('bloo-bar__thumb--active');
          var mainImg = section.querySelector('[data-bloo-bar-main]');
          var thumbImg = thumb.querySelector('img');
          if (mainImg && thumbImg) {
            mainImg.src = thumbImg.dataset.full || thumbImg.src;
            mainImg.dataset.large = thumbImg.dataset.large || thumbImg.dataset.full || thumbImg.src;
          }
        });
      });

      // LIGHTBOX
      var lightbox = section.querySelector('[data-bloo-bar-lightbox]');
      var lightboxImg = section.querySelector('[data-bloo-bar-lightbox-img]');
      var zoomTrigger = section.querySelector('[data-bloo-bar-zoom-trigger]');
      var lightboxClose = section.querySelector('[data-bloo-bar-lightbox-close]');

      function openLightbox() {
        if (!lightbox || !lightboxImg) return;
        var mainImg = section.querySelector('[data-bloo-bar-main]');
        if (!mainImg) return;
        lightboxImg.src = mainImg.dataset.large || mainImg.src;
        lightboxImg.alt = mainImg.alt || '';
        if (typeof lightbox.showModal === 'function') {
          lightbox.showModal();
        } else {
          lightbox.setAttribute('open', '');
        }
      }

      function closeLightbox() {
        if (!lightbox) return;
        if (typeof lightbox.close === 'function') {
          lightbox.close();
        } else {
          lightbox.removeAttribute('open');
        }
      }

      if (zoomTrigger) zoomTrigger.addEventListener('click', openLightbox);
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      if (lightboxImg) lightboxImg.addEventListener('click', closeLightbox);
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) closeLightbox();
        });
      }

      var addBtn = section.querySelector('[data-bloo-bar-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addSelected(addBtn, 'ADD TO CART');
        });
      }

      var stickyAddBtn = section.querySelector('[data-bloo-bar-sticky-add]');
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function () {
          addSelected(stickyAddBtn, 'Add To Cart');
        });
      }

      updateUI();
      updateStickyState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloo-before-after"]) return;
  try {
    
  (function () {
    if (window.blooCompareReady) return;
    window.blooCompareReady = true;

    function bind(compare) {
      var range = compare.querySelector('[data-bloo-compare-range]');
      var dragging = false;
      function set(pct) {
        pct = Math.max(0, Math.min(100, pct));
        compare.style.setProperty('--pos', pct + '%');
        if (range) range.value = Math.round(pct);
      }
      function fromPointer(event) {
        var rect = compare.getBoundingClientRect();
        set(((event.clientX - rect.left) / rect.width) * 100);
      }
      compare.addEventListener('pointerdown', function (event) {
        dragging = true;
        compare.setPointerCapture(event.pointerId);
        fromPointer(event);
      });
      compare.addEventListener('pointermove', function (event) { if (dragging) fromPointer(event); });
      compare.addEventListener('pointerup', function () { dragging = false; });
      compare.addEventListener('pointercancel', function () { dragging = false; });
      if (range) range.addEventListener('input', function () { set(Number(range.value)); });
    }

    function init() { document.querySelectorAll('[data-bloo-compare]').forEach(bind); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloo-bundle-builder"]) return;
  try {
    
  (function () {
    function ensurePurchaseStickyController() {
      if (window.blooPurchaseStickyControllerReady) return;
      window.blooPurchaseStickyControllerReady = true;
      window.blooRefreshPurchaseStickies = function () {
        var configs = [
          { selector: '[data-bloo-bundle]', className: 'bloo-bundle--sticky-visible', atc: '[data-bloo-bundle-add]' },
          { selector: '[data-bloo-sw]', className: 'bloo-sw--sticky-visible', atc: '[data-bloo-add-to-cart]' },
          { selector: '[data-bloo-bar]', className: 'bloo-bar--sticky-visible', atc: '[data-bloo-bar-add]' }
        ];
        var isMobile = window.matchMedia('(max-width: 768px), (max-width: 932px) and (hover: none) and (pointer: coarse)').matches;
        var cartDrawerOpen = !!document.querySelector('cart-drawer.active') || document.body.classList.contains('overflow-hidden');
        var visualViewport = window.visualViewport;
        var layoutHeight = document.documentElement.clientHeight || window.innerHeight;
        var viewportHeight = visualViewport ? visualViewport.height : (window.innerHeight || layoutHeight);
        var viewportOffsetTop = visualViewport ? visualViewport.offsetTop : 0;
        var stickyBottom = visualViewport ? Math.max(0, layoutHeight - visualViewport.height - viewportOffsetTop) : 0;
        var active = null;
        var mainAddVisible = false;

        document.documentElement.style.setProperty('--bloo-sticky-bottom', stickyBottom + 'px');

        configs.forEach(function (config) {
          document.querySelectorAll(config.selector).forEach(function (section) {
            section.classList.remove(config.className);
            if (!isMobile || cartDrawerOpen) return;

            var rect = section.getBoundingClientRect();
            var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
            if (visibleHeight <= 80) return;

            // The bar duplicates each section's own Add to Cart, so stay hidden while any of those buttons is on screen.

            var mainAdd = config.atc && section.querySelector(config.atc);

            if (mainAdd) {

              var addRect = mainAdd.getBoundingClientRect();

              if (addRect.height && addRect.bottom > 0 && addRect.top < viewportHeight) mainAddVisible = true;

            }

            var centerDistance = Math.abs((rect.top + rect.bottom) / 2 - viewportHeight / 2);
            var score = visibleHeight - centerDistance * 0.01;
            if (!active || score > active.score) {
              active = { section: section, className: config.className, score: score };
            }
          });
        });

	        if (mainAddVisible) active = null;

	        if (active) active.section.classList.add(active.className);
	        document.body.classList.toggle('bloo-purchase-sticky-active', !!active);
	      };

      window.addEventListener('scroll', window.blooRefreshPurchaseStickies, { passive: true });
      window.addEventListener('resize', window.blooRefreshPurchaseStickies);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', window.blooRefreshPurchaseStickies);
        window.visualViewport.addEventListener('scroll', window.blooRefreshPurchaseStickies);
      }
    }

    function getSelectedVariantId(section) {
      var formula = section.dataset.activeFormula;
      var stack = section.dataset.activeStack;
      var key = 'variant' + formula.charAt(0).toUpperCase() + formula.slice(1) + stack.charAt(0).toUpperCase() + stack.slice(1);
      return section.dataset[key];
    }

    function addSelectedBundle(section, button) {
      var variantId = getSelectedVariantId(section);
      var idleText = button.textContent.trim();
      if (!variantId) {
        button.textContent = 'BUNDLE NOT LIVE YET';
        setTimeout(function () {
          button.textContent = idleText;
        }, 1600);
        return;
      }

      blooAddToCart({ id: variantId, quantity: 1 }, button, idleText);
    }

    function formatPresentmentMoney(cents, currencyCode) {
      var amount = Math.max(0, cents) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2) + ' ' + currencyCode;
      }
    }

    function updateShippingCopy(section) {
      var currency = window.Shopify && window.Shopify.currency;
      var rate = currency ? Number(currency.rate) : NaN;
      var thresholdUsdCents = Number(section.dataset.freeShippingUsdCents);
      if (!currency || !currency.active || !Number.isFinite(rate) || rate <= 0 || !thresholdUsdCents) return;

      var thresholdPresentmentCents = Math.round(thresholdUsdCents * rate);
      var market = section.dataset.freeShippingMarket || 'international';
      var goalCopy = market === 'US' ? 'free US shipping' : 'free international shipping';
      var qualifyingCopy = market === 'US' ? 'Includes free US shipping' : 'Includes free international shipping';

      section.querySelectorAll('[data-bloo-bundle-card]').forEach(function (card) {
        var priceCents = Number(card.dataset.priceCents);
        if (!Number.isFinite(priceCents)) return;

        var remainingCents = thresholdPresentmentCents - priceCents;
        var shippingCopy = remainingCents > 0
          ? 'Add ' + formatPresentmentMoney(remainingCents, currency.active) + ' more for ' + goalCopy
          : qualifyingCopy;
        var cardShipping = card.querySelector('[data-bloo-bundle-card-shipping]');

        card.dataset.shipping = shippingCopy;
        if (cardShipping) cardShipping.textContent = shippingCopy;
      });
    }

    function updateUI(section) {
      var activeFormula = section.dataset.activeFormula;
      var activeStack = section.dataset.activeStack;
      var formulaLabel = activeFormula === 'blooless' ? 'BLOOLESS' : 'BLOO';

      section.querySelectorAll('[data-bloo-bundle-formula]').forEach(function (btn) {
        var isActive = btn.dataset.blooBundleFormula === activeFormula;
        btn.classList.toggle('bloo-bundle__toggle-btn--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      section.querySelectorAll('[data-bloo-bundle-card]').forEach(function (card) {
        var isSelected = card.dataset.stack === activeStack;
        card.classList.toggle('bloo-bundle__card--selected', isSelected);
        card.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });

      var formulaLabelEl = section.querySelector('[data-bloo-bundle-formula-label]');
      if (formulaLabelEl) formulaLabelEl.textContent = formulaLabel;

      section.querySelectorAll('[data-bloo-bundle-card-title]').forEach(function (title) {
        title.textContent = (title.dataset.template || '').replace('{formula}', formulaLabel);
      });

      var selectedCard = section.querySelector('[data-bloo-bundle-card][data-stack="' + activeStack + '"]');
      if (selectedCard) {
        var price = section.querySelector('[data-bloo-bundle-price]');
        var compare = section.querySelector('[data-bloo-bundle-compare]');
        var shipping = section.querySelector('[data-bloo-bundle-shipping]');
        var stickyTitle = section.querySelector('[data-bloo-bundle-sticky-title]');
        var stickyPrice = section.querySelector('[data-bloo-bundle-sticky-price]');

        if (price) price.textContent = selectedCard.dataset.price || '';
        if (compare) compare.textContent = selectedCard.dataset.compare || '';
        if (stickyTitle) {
          var title = selectedCard.querySelector('[data-bloo-bundle-card-title]');
          stickyTitle.textContent = title ? title.textContent : '';
        }
        if (stickyPrice) stickyPrice.textContent = selectedCard.dataset.price || '';
        if (shipping) shipping.textContent = selectedCard.dataset.shipping || '';
      }

      var addBtn = section.querySelector('[data-bloo-bundle-add]');
      if (addBtn) {
        var hasVariant = !!getSelectedVariantId(section);
        var selectedTitle = selectedCard ? selectedCard.querySelector('[data-bloo-bundle-card-title]') : null;
        var selectedPrice = selectedCard ? selectedCard.dataset.price : '';
        addBtn.disabled = false;
        addBtn.textContent = 'Add ' + (selectedTitle ? selectedTitle.textContent : 'bundle') + ' — ' + selectedPrice;
        addBtn.setAttribute('aria-disabled', hasVariant ? 'false' : 'true');
      }

      var stickyAdd = section.querySelector('[data-bloo-bundle-sticky-add]');
      if (stickyAdd) {
        stickyAdd.textContent = 'Add Bundle';
        stickyAdd.setAttribute('aria-disabled', getSelectedVariantId(section) ? 'false' : 'true');
      }
    }

    function initSections() {
      document.querySelectorAll('[data-bloo-bundle]').forEach(function (section) {
        section.dataset.blooBound = 'true';
        updateShippingCopy(section);
        updateUI(section);
        updateStickyState(section);
      });
    }

    function updateStickyState(section) {
      if (window.blooRefreshPurchaseStickies) window.blooRefreshPurchaseStickies();
    }

    function refreshStickyStates() {
      if (window.blooRefreshPurchaseStickies) window.blooRefreshPurchaseStickies();
    }

    ensurePurchaseStickyController();

    if (!window.blooBundleDelegatedClick) {
      window.blooBundleDelegatedClick = true;
      document.addEventListener('click', function (event) {
        var formulaBtn = event.target.closest('[data-bloo-bundle-formula]');
        if (formulaBtn) {
          var formulaSection = formulaBtn.closest('[data-bloo-bundle]');
          if (!formulaSection) return;
          formulaSection.dataset.activeFormula = formulaBtn.dataset.blooBundleFormula;
          updateUI(formulaSection);
          return;
        }

        var card = event.target.closest('[data-bloo-bundle-card]');
        if (card) {
          var cardSection = card.closest('[data-bloo-bundle]');
          if (!cardSection) return;
          cardSection.dataset.activeStack = card.dataset.stack;
          updateUI(cardSection);
          return;
        }

        var addBtn = event.target.closest('[data-bloo-bundle-add]');
        var stickyAddBtn = event.target.closest('[data-bloo-bundle-sticky-add]');
        if (addBtn || stickyAddBtn) {
          var button = addBtn || stickyAddBtn;
          var addSection = button.closest('[data-bloo-bundle]');
          if (!addSection) return;
          addSelectedBundle(addSection, button);
        }
      });

      document.addEventListener('shopify:section:load', initSections);
      document.addEventListener('shopify:section:unload', refreshStickyStates);
    }

    initSections();
    refreshStickyStates();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloo-email"]) return;
  try {
    
  // If Klaviyo doesn't render its form within 4s, mark the section empty so
  // the layout collapses gracefully instead of leaving a dead column.
  (function () {
    document.querySelectorAll('.bloo-email').forEach(function (section) {
      var container = section.querySelector('.bloo-email__klaviyo');
      if (!container) return;
      setTimeout(function () {
        var hasContent = container.querySelector('[class*="klaviyo-form-"]')?.children.length > 0
          || container.querySelector('form, input, button');
        if (!hasContent) {
          section.dataset.blooEmailEmpty = 'true';
        }
      }, 4000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloo-nav"]) return;
  try {
    
  (function () {
    var nav = document.querySelector('.bloo-nav');
    if (!nav || nav.dataset.blooBound === 'true') return;
    nav.dataset.blooBound = 'true';

    var toggle = nav.querySelector('[data-bloo-menu-toggle]');
    function closeMobileMenu(returnFocus) {
      nav.dataset.blooMenuOpen = 'false';
      if (!toggle) return;
      toggle.setAttribute('aria-label', 'Open menu');
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = nav.dataset.blooMenuOpen === 'true';
        nav.dataset.blooMenuOpen = open ? 'false' : 'true';
        toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }

    nav.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.dataset.blooMenuOpen === 'true') {
        closeMobileMenu(true);
      }
    });

    nav.querySelectorAll('[data-bloo-menu-close]').forEach(function (a) {
      a.addEventListener('click', function () {
        closeMobileMenu(false);
      });
    });


    // Wire the mobile-menu cart link to open the cart drawer.
    // (Desktop cart icon uses id="cart-icon-bubble" which cart-drawer.js auto-hijacks.)
    nav.querySelectorAll('[data-bloo-cart-trigger]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return; // no JS / no drawer → fall through to /cart
        event.preventDefault();
        // Close the mobile menu first so the drawer animates over a clean nav.
        closeMobileMenu(false);
        drawer.open(link);
      });
    });
  })();

  (function () {
    function syncCartDrawerViewport() {
      var viewport = window.visualViewport;
      if (!viewport) {
        document.documentElement.style.removeProperty('--bloo-cart-drawer-height');
        return;
      }

      document.documentElement.style.setProperty('--bloo-cart-drawer-height', Math.round(viewport.height) + 'px');
    }

    syncCartDrawerViewport();
    window.addEventListener('resize', syncCartDrawerViewport, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncCartDrawerViewport, { passive: true });
    }
  })();

  /* Shared add-to-cart helper used by bloo-scalp-wash and bloo-bar. */
  function blooCartRequest(url, options) {
    options = options || {};
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      Object.keys(options.headers || {}).forEach(function (name) {
        xhr.setRequestHeader(name, options.headers[name]);
      });
      xhr.onload = function () {
        resolve({
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status,
          responseText: xhr.responseText
        });
      };
      xhr.onerror = function () { reject(new Error('Network error while updating cart.')); };
      xhr.send(options.body || null);
    });
  }

  function blooSubmitCartForm(item, shopifyRoot) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = shopifyRoot + 'cart/add';
    form.hidden = true;

    Object.keys(item).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = item[name];
      form.appendChild(input);
    });

    var returnInput = document.createElement('input');
    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    returnInput.value = window.location.pathname + window.location.search + window.location.hash;
    form.appendChild(returnInput);
    document.body.appendChild(form);
    form.submit();
  }

  window.blooAddToCart = function (item, btn, restoreLabel) {
    if (!item || !item.id) return;
    var shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var origLabel = restoreLabel || (btn && btn.textContent) || 'ADD TO CART';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'ADDING...';
    }

    if (typeof window.XMLHttpRequest !== 'function') {
      blooSubmitCartForm(item, shopifyRoot);
      return;
    }

    blooCartRequest(shopifyRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [item],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
      })
      .then(function (r) {
        var data;
        try {
          data = JSON.parse(r.responseText);
        } catch (parseError) {
          throw new Error('Could not add to cart. Please try again.');
        }
        if (!r.ok) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        return data;
      })
      .then(function (data) {
        if (data.status && data.status >= 400) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }

        var drawer = document.querySelector('cart-drawer');

        // Replace the drawer's inner HTML with the freshly-rendered server section.
        if (drawer && data.sections && data.sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          var newInner = doc.querySelector('#CartDrawer');
          var oldInner = document.querySelector('#CartDrawer');
          if (newInner && oldInner) {
            oldInner.innerHTML = newInner.innerHTML;
          }
          if (window.blooUpdateShippingNudges) window.blooUpdateShippingNudges(drawer);
          // The original overlay (and its click-to-close handler) was just blown away.
          // Re-attach the close handler to the new overlay so the user can dismiss.
          var newOverlay = document.querySelector('#CartDrawer-Overlay');
          if (newOverlay && typeof drawer.close === 'function') {
            newOverlay.addEventListener('click', function () { drawer.close(); });
          }
        }

        if (drawer) {
          drawer.classList.remove('is-empty');
          // setTimeout to let the DOM updates settle before triggering the open animation.
          setTimeout(function () {
            if (typeof drawer.open === 'function') {
              drawer.open();
            } else {
              drawer.classList.add('active');
              document.body.classList.add('overflow-hidden');
            }
          });
        }

        // Update the cart icon count from the locale-aware cart endpoint.
        return blooCartRequest(shopifyRoot + 'cart.js');
      })
      .then(function (r) {
        if (!r) return null;
        try { return JSON.parse(r.responseText); }
        catch (parseError) { return null; }
      })
      .then(function (cart) {
        if (cart) {
          var iconLinks = document.querySelectorAll('#cart-icon-bubble, [data-bloo-mobile-cart]');
          iconLinks.forEach(function (iconLink) {
            var existing = iconLink.querySelector('.bloo-nav__cart-count');
            if (existing) existing.remove();
            if (cart.item_count > 0) {
              var bubble = document.createElement('span');
              bubble.className = 'bloo-nav__cart-count';
              bubble.setAttribute('aria-hidden', 'true');
              bubble.textContent = cart.item_count;
              iconLink.appendChild(bubble);
            }
          });
        }
        if (btn) {
          btn.textContent = 'ADDED ✓';
          setTimeout(function () {
            btn.textContent = origLabel;
            btn.disabled = false;
          }, 1200);
        }
      })
      .catch(function (err) {
        console.error('[BLOO] Add to cart failed:', err);
        if (btn) {
          btn.textContent = 'TRY AGAIN';
          setTimeout(function () {
            btn.textContent = origLabel;
            btn.disabled = false;
          }, 2000);
        }
      });
  };

  if (!window.blooCartUpgradeBound) {
    window.blooCartUpgradeBound = true;
    document.addEventListener('click', function (event) {
      var upgradeButton = event.target.closest('[data-bloo-cart-upgrade]');
      if (!upgradeButton) return;
      event.preventDefault();
      var variantId = Number(upgradeButton.dataset.variantId);
      if (!variantId) return;
      window.blooAddToCart(
        { id: variantId, quantity: 1 },
        upgradeButton,
        upgradeButton.textContent.trim()
      );
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloo-reviews"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.bloo-reviews').forEach(function (section) {
      if (section.dataset.blooReviewsBound === 'true') return;
      section.dataset.blooReviewsBound = 'true';

      var toggle = section.querySelector('[data-bloo-reviews-toggle]');
      var label = section.querySelector('[data-bloo-reviews-toggle-label]');
      if (!toggle || !label) return;

      toggle.addEventListener('click', function () {
        var expanded = section.classList.toggle('bloo-reviews--expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        label.textContent = expanded ? 'Show fewer reviews' : 'Show 9 more reviews';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloo-scalp-wash"]) return;
  try {
    
  (function () {
    function ensurePurchaseStickyController() {
      if (window.blooPurchaseStickyControllerReady) return;
      window.blooPurchaseStickyControllerReady = true;
      window.blooRefreshPurchaseStickies = function () {
        var configs = [
          { selector: '[data-bloo-bundle]', className: 'bloo-bundle--sticky-visible', atc: '[data-bloo-bundle-add]' },
          { selector: '[data-bloo-sw]', className: 'bloo-sw--sticky-visible', atc: '[data-bloo-add-to-cart]' },
          { selector: '[data-bloo-bar]', className: 'bloo-bar--sticky-visible', atc: '[data-bloo-bar-add]' }
        ];
        var isMobile = window.matchMedia('(max-width: 768px), (max-width: 932px) and (hover: none) and (pointer: coarse)').matches;
        var cartDrawerOpen = !!document.querySelector('cart-drawer.active') || document.body.classList.contains('overflow-hidden');
        var visualViewport = window.visualViewport;
        var layoutHeight = document.documentElement.clientHeight || window.innerHeight;
        var viewportHeight = visualViewport ? visualViewport.height : (window.innerHeight || layoutHeight);
        var viewportOffsetTop = visualViewport ? visualViewport.offsetTop : 0;
        var stickyBottom = visualViewport ? Math.max(0, layoutHeight - visualViewport.height - viewportOffsetTop) : 0;
        var active = null;
        var mainAddVisible = false;

        document.documentElement.style.setProperty('--bloo-sticky-bottom', stickyBottom + 'px');

        configs.forEach(function (config) {
          document.querySelectorAll(config.selector).forEach(function (section) {
            section.classList.remove(config.className);
            if (!isMobile || cartDrawerOpen) return;

            var rect = section.getBoundingClientRect();
            var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
            if (visibleHeight <= 80) return;

            // The bar duplicates each section's own Add to Cart, so stay hidden while any of those buttons is on screen.

            var mainAdd = config.atc && section.querySelector(config.atc);

            if (mainAdd) {

              var addRect = mainAdd.getBoundingClientRect();

              if (addRect.height && addRect.bottom > 0 && addRect.top < viewportHeight) mainAddVisible = true;

            }

            var centerDistance = Math.abs((rect.top + rect.bottom) / 2 - viewportHeight / 2);
            var score = visibleHeight - centerDistance * 0.01;
            if (!active || score > active.score) {
              active = { section: section, className: config.className, score: score };
            }
          });
        });

	        if (mainAddVisible) active = null;

	        if (active) active.section.classList.add(active.className);
	        document.body.classList.toggle('bloo-purchase-sticky-active', !!active);
	      };

      window.addEventListener('scroll', window.blooRefreshPurchaseStickies, { passive: true });
      window.addEventListener('resize', window.blooRefreshPurchaseStickies);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', window.blooRefreshPurchaseStickies);
        window.visualViewport.addEventListener('scroll', window.blooRefreshPurchaseStickies);
      }
    }

    ensurePurchaseStickyController();

    document.querySelectorAll('[data-bloo-sw]').forEach(function (section) {
      if (section.dataset.blooBound === 'true') return;
      section.dataset.blooBound = 'true';

      var ingredientCloseTimer = null;

      function closeIngredientCards(exceptKey) {
        section.querySelectorAll('[data-bloo-ingredient-card]').forEach(function (card) {
          if (card.dataset.blooIngredientCard !== exceptKey) card.hidden = true;
        });
        section.querySelectorAll('[data-bloo-ingredient]').forEach(function (trigger) {
          if (trigger.dataset.blooIngredient !== exceptKey) trigger.setAttribute('aria-expanded', 'false');
        });
      }

      function setIngredientCard(trigger, forceOpen) {
        var key = trigger.dataset.blooIngredient;
        var card = section.querySelector('[data-bloo-ingredient-card="' + key + '"]');
        if (!card) return;
        var shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : card.hidden;
        closeIngredientCards(shouldOpen ? key : null);
        card.hidden = !shouldOpen;
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      section.querySelectorAll('[data-bloo-ingredient]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.stopPropagation();
          var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          setIngredientCard(trigger, supportsHover ? true : undefined);
        });
        trigger.addEventListener('mouseenter', function () {
          window.clearTimeout(ingredientCloseTimer);
          setIngredientCard(trigger, true);
        });
        trigger.addEventListener('focus', function () { setIngredientCard(trigger, true); });
        trigger.addEventListener('mouseleave', function () {
          ingredientCloseTimer = window.setTimeout(function () { closeIngredientCards(); }, 140);
        });
      });

      section.querySelectorAll('[data-bloo-ingredient-card]').forEach(function (card) {
        card.addEventListener('mouseenter', function () { window.clearTimeout(ingredientCloseTimer); });
        card.addEventListener('mouseleave', function () {
          ingredientCloseTimer = window.setTimeout(function () { closeIngredientCards(); }, 140);
        });
      });

      section.addEventListener('focusout', function (event) {
        var ingredients = section.querySelector('[data-bloo-ingredient-popovers]');
        if (ingredients && !ingredients.contains(event.relatedTarget)) closeIngredientCards();
      });
      document.addEventListener('click', function (event) {
        var ingredients = section.querySelector('[data-bloo-ingredient-popovers]');
        if (ingredients && !ingredients.contains(event.target)) closeIngredientCards();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeIngredientCards();
      });

      function updateUI() {
        var activeProduct = section.dataset.activeProduct;
        var activePlan = section.dataset.activePlan;
        var activeQty = section.dataset.activeQty;
        var activeFrequency = section.dataset.activeFrequency || 'four';
        var productLabel = activeProduct === 'blooless' ? 'BLOOLESS' : 'BLOO';

        section.querySelectorAll('[data-bloo-variant]').forEach(function (btn) {
          var isActive = btn.dataset.blooVariant === activeProduct;
          btn.classList.toggle('bloo-sw__variant-btn--active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        var brandLabel = section.querySelector('[data-bloo-brand-label]');
        if (brandLabel) {
          brandLabel.textContent = productLabel;
        }

        var lede = section.querySelector('.bloo-sw__lede');
        if (lede) {
          lede.textContent = activeProduct === 'blooless' ? lede.dataset.ledeBlooless : lede.dataset.ledeBloo;
        }

        section.querySelectorAll('[data-bloo-formula]').forEach(function (el) {
          el.hidden = el.dataset.blooFormula !== activeProduct;
        });

        if (activeProduct === 'blooless') {
          var methyleneTrigger = section.querySelector('[data-bloo-ingredient="methylene"]');
          var methyleneCard = section.querySelector('[data-bloo-ingredient-card="methylene"]');
          if (methyleneTrigger) methyleneTrigger.setAttribute('aria-expanded', 'false');
          if (methyleneCard) methyleneCard.hidden = true;
        }

        section.querySelectorAll('[data-bloo-main-image], [data-bloo-thumb] img').forEach(function (img) {
          var src = activeProduct === 'blooless' ? img.dataset.srcBlooless : img.dataset.srcBloo;
          if (src && img.getAttribute('src') !== src) img.src = src;
        });

        section.querySelectorAll('[data-bloo-plan]').forEach(function (tab) {
          var isActive = tab.dataset.blooPlan === activePlan;
          tab.classList.toggle('bloo-sw__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('[data-bloo-frequency]').forEach(function (btn) {
          var isActive = btn.dataset.blooFrequency === activeFrequency;
          btn.classList.toggle('bloo-sw__frequency-btn--active', isActive);
          btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('[data-bloo-card]').forEach(function (card) {
          var isSelected = card.dataset.qty === activeQty;
          card.classList.toggle('bloo-sw__card--selected', isSelected);
          card.setAttribute('aria-checked', isSelected ? 'true' : 'false');

          var priceEl = card.querySelector('.bloo-sw__price');
          if (priceEl) {
            var newPrice = activePlan === 'onetime'
              ? priceEl.dataset.priceOnetime
              : priceEl.dataset.priceSubscribe;
            if (newPrice) priceEl.textContent = newPrice;
          }

          var subEl = card.querySelector('.bloo-sw__card-sub');
          if (subEl) {
            var newSub = activePlan === 'onetime'
              ? subEl.dataset.subOnetime
              : subEl.dataset.subSubscribe;
            if (newSub) subEl.innerHTML = newSub;
          }
        });

        var selectedCard = section.querySelector('[data-bloo-card][data-qty="' + activeQty + '"]');
        if (selectedCard) {
          var headerPriceEl = section.querySelector('[data-bloo-sw-price]');
          var headerStrikeEl = section.querySelector('[data-bloo-sw-strike]');
          var headerPerDayEl = section.querySelector('[data-bloo-sw-perday]');
          var headerPillEl = section.querySelector('[data-bloo-sw-pill]');

          var cardPriceEl = selectedCard.querySelector('.bloo-sw__price');
          var cardStrikeEl = selectedCard.querySelector('.bloo-sw__strike');

          if (headerPriceEl && cardPriceEl) headerPriceEl.textContent = cardPriceEl.textContent;
          if (headerStrikeEl) {
            if (cardStrikeEl) {
              headerStrikeEl.textContent = cardStrikeEl.textContent;
              headerStrikeEl.style.display = '';
            } else {
              headerStrikeEl.style.display = 'none';
            }
          }
          if (headerPerDayEl) {
            var perDayValue = activePlan === 'onetime'
              ? headerPerDayEl.dataset.perdayOnetime
              : headerPerDayEl.dataset.perdaySubscribe;
            if (perDayValue) headerPerDayEl.textContent = perDayValue;
          }
          if (headerPillEl) {
            var pillMap = { '1': '1 BAG', '2': '2 BAGS', '3': '3 BAGS' };
            headerPillEl.textContent = pillMap[activeQty] || '';
          }

          var stickyTitle = section.querySelector('[data-bloo-sw-sticky-title]');
          var stickyPrice = section.querySelector('[data-bloo-sw-sticky-price]');
          if (stickyTitle) {
            var titleMap = { '1': '1 Bag', '2': '2 Bags', '3': '3 Bags' };
            stickyTitle.textContent = productLabel + ' ' + (titleMap[activeQty] || 'Scalp Wash');
          }
          if (stickyPrice && headerPriceEl) stickyPrice.textContent = headerPriceEl.textContent;
        }

      }

      function updateStickyState() {
        if (window.blooRefreshPurchaseStickies) window.blooRefreshPurchaseStickies();
      }

      function addSelected(button, idleText) {
        var variantId = section.dataset.activeProduct === 'blooless'
          ? section.dataset.variantBlooless
          : section.dataset.variantBloo;
        var qty = parseInt(section.dataset.activeQty, 10);
        var sellingPlan = null;
        if (section.dataset.activePlan === 'subscribe') {
          var frequencySuffix = { four: 'Four', six: 'Six', eight: 'Eight' };
          var suffix = frequencySuffix[section.dataset.activeFrequency] || 'Four';
          var productKey = section.dataset.activeProduct === 'blooless'
            ? 'sellingPlanBlooless'
            : 'sellingPlanBloo';
          sellingPlan = section.dataset[productKey + suffix] || section.dataset[productKey + 'Four'];
        }
        var item = { id: variantId, quantity: qty };
        if (sellingPlan) item.selling_plan = sellingPlan;
        blooAddToCart(item, button, idleText);
      }

      section.querySelectorAll('[data-bloo-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          section.dataset.activeProduct = btn.dataset.blooVariant;
          updateUI();
          updateStickyState();
        });
      });

      section.querySelectorAll('[data-bloo-plan]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          section.dataset.activePlan = tab.dataset.blooPlan;
          updateUI();
          updateStickyState();
        });
      });

      section.querySelectorAll('[data-bloo-frequency]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          section.dataset.activeFrequency = btn.dataset.blooFrequency;
          updateUI();
          updateStickyState();
        });
      });

      section.querySelectorAll('[data-bloo-card]').forEach(function (card) {
        card.addEventListener('click', function () {
          section.dataset.activeQty = card.dataset.qty;
          updateUI();
          updateStickyState();
        });
      });

      section.querySelectorAll('[data-bloo-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          section.querySelectorAll('[data-bloo-thumb]').forEach(function (t) {
            t.classList.remove('bloo-sw__thumb--active');
            t.setAttribute('aria-pressed', 'false');
          });
          thumb.classList.add('bloo-sw__thumb--active');
          thumb.setAttribute('aria-pressed', 'true');
          var mainImg = section.querySelector('[data-bloo-main-image]');
          var thumbImg = thumb.querySelector('img');
          if (mainImg && thumbImg) {
            mainImg.dataset.srcBloo = thumbImg.dataset.srcBloo || thumbImg.src;
            mainImg.dataset.srcBlooless = thumbImg.dataset.srcBlooless || thumbImg.src;
            mainImg.dataset.largeBloo = thumbImg.dataset.largeBloo || thumbImg.dataset.srcBloo || thumbImg.src;
            mainImg.dataset.largeBlooless = thumbImg.dataset.largeBlooless || thumbImg.dataset.srcBlooless || thumbImg.src;
            var activeProduct = section.dataset.activeProduct;
            mainImg.src = activeProduct === 'blooless'
              ? mainImg.dataset.srcBlooless
              : mainImg.dataset.srcBloo;
          }
        });
      });

      // LIGHTBOX
      var lightbox = section.querySelector('[data-bloo-lightbox]');
      var lightboxImg = section.querySelector('[data-bloo-lightbox-img]');
      var zoomTrigger = section.querySelector('[data-bloo-zoom-trigger]');
      var lightboxClose = section.querySelector('[data-bloo-lightbox-close]');

      function openLightbox() {
        if (!lightbox || !lightboxImg) return;
        var mainImg = section.querySelector('[data-bloo-main-image]');
        if (!mainImg) return;
        var activeProduct = section.dataset.activeProduct;
        var largeSrc = activeProduct === 'blooless'
          ? (mainImg.dataset.largeBlooless || mainImg.src)
          : (mainImg.dataset.largeBloo || mainImg.src);
        lightboxImg.src = largeSrc;
        lightboxImg.alt = mainImg.alt || '';
        if (typeof lightbox.showModal === 'function') {
          lightbox.showModal();
        } else {
          lightbox.setAttribute('open', '');
        }
      }

      function closeLightbox() {
        if (!lightbox) return;
        if (typeof lightbox.close === 'function') {
          lightbox.close();
        } else {
          lightbox.removeAttribute('open');
        }
      }

      if (zoomTrigger) zoomTrigger.addEventListener('click', openLightbox);
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      if (lightboxImg) lightboxImg.addEventListener('click', closeLightbox);
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) closeLightbox();
        });
      }

      var addBtn = section.querySelector('[data-bloo-add-to-cart]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addSelected(addBtn, 'ADD TO CART');
        });
      }

      var stickyAddBtn = section.querySelector('[data-bloo-sw-sticky-add]');
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function () {
          addSelected(stickyAddBtn, 'Add To Cart');
        });
      }

      updateUI();
      updateStickyState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
